import type { CategoryDetailResponse } from '@yoop/server-model/inventory-category';
import type { AvailableSection, AvailableSectionV2 } from '@yoop/server-model/inventory-section';
import type { SalesGroupNodeResponse } from './sales-group-node-response';
import type { SeatConfigurationType } from '@yoop/server-model/seating';
//Not sure if this should be a dependency or SimpleOfferResponse on it's own lib
import type { LocationGateResponse, SimpleOfferResponse } from '@yoop/server-model/token-info';
import type { TieredDiscountListResponse } from './tiered-discount-list-response';

export enum Demand {
  NORMAL = 'NORMAL',
  HIGH = 'HIGH',
  DEMAND_EXCEEDS_SUPPLY = 'DEMAND_EXCEEDS_SUPPLY',
}

export interface SuggestedOfferIncrementResponse {
  id: number;
  title: string;
  value: number;
}

export interface SimpleOfferGroupResponse {
  activeOffer?: SimpleOfferResponse;

  additionalDetails?: string;

  /* The average price of offers in this group, null if no offer exists yet */
  averageOfferPrice?: number;

  /* Quantities that user cannot pick to keep seats/listings as "together" as possible */
  blacklistedQuantities?: number[];

  /* The capacity tag shown inside the offer group listing */
  capacityDefaultString?: string;

  /* Any extra details regarding the category this offer group belongs to. */
  categoryDetail?: CategoryDetailResponse;

  categoryId?: string;

  categoryName?: string;

  /* The demand of this offerGroup */
  demand?: Demand;

  /* The description for the offer group */
  description: string;

  /* The end date for the offer group */
  endDate?: string;

  /* Data about which gates can be used to access seats in this offer group. */
  gates?: LocationGateResponse[];

  /* Information about the sales group this offer group belongs to */
  salesGroupNodeResponse?: SalesGroupNodeResponse;

  /* The unique identifier for this group */
  id: string;

  /* Indicates whether offer group is almost sold out */
  lowCapacityThresholdPassed: boolean;

  /* The minimum offer price to buy one token */
  minQualifyingPrice?: number;

  /* The number of tokens in this group */
  numberOfTokens?: number;

  /* The reserve price for this group */
  reservePrice: number;

  allInPrice: number;
  /* The discounted price for this offer group after coupons and such */
  discountedPrice?: number;

  /* Whether or not this offer group is GENERAL_ADMISSION or SEATED */
  seatConfigurationType?: SeatConfigurationType;

  /* The sections containing inventory for this offer group. */
  /***
   * @deprecated: use `availableSections` instead.
   */
  sections?: AvailableSection[];
  availableSections?: AvailableSectionV2[];

  boxOfficeExclusiveSoldOutString?: string;
  scheduledBoxOfficeExclusiveSoldOutString?: string;

  soldOut?: boolean;

  suggestedOfferIncrements?: SuggestedOfferIncrementResponse[];

  /* This identifies if an offer group can have a different price then default. Old MarketplaceType.PURCHASE_DYNAMIC_PRICE */
  allowDynamicPrice?: boolean;

  marketplaceId?: number;

  ranking?: number;

  tieredDiscountList?: TieredDiscountListResponse;

  //This string represents the message to display on what's missing in order to allow purchase of this offer group.
  missingRequirements?: string;

  checkoutResaleText?: string;
}
